import { EVisitorIntegrationEnum } from "@/shared/models/enums.type";
import { ReservationCheckInCustomerData } from "./CheckinTypes";
import { Country } from "@/shared/models/country";
import { IdentificationDocumentTypesEnum } from "@/shared/enums/identificationDocumentTypes.type";

export interface OcrData {
  line1: string | null;
  line2: string | null;
  line3: string | null;

  docId: string | null;
  docType: "IDENTITY CARD" | "PASSPORT";
  docNumber: string | null;

  surname: string | null;
  forename: string | null;
  secondName: string | null;
  forenames: string | null;

  dateOfBirth: string;
  expiryDate: string;

  issuingState: string | null;
  nationality: string | null;

  sex: "Male" | "Female";

  optionalData1: string | null;
  optionalData2: string | null;

  checkDigitValid: boolean;

  isValid: boolean;
}

/**
 * Finds nokumo country. Handles override
 * @param ocrCountry ISO3, but in some cases might be different (e.g. 'D' instead of 'DEU')
 * @param countries nokumo countries to match against
 */
function findCountry(
  ocrCountry: string | null | undefined,
  countries: Country[]
): Country | undefined {
  if (!ocrCountry) return undefined;

  const term = ocrCountry.toUpperCase();

  let found = countries.find((x) => term === x.mrzCodeOverride?.toUpperCase());

  if (!found) {
    found = countries.find((x) => term === x.isoThreeLetterCode?.toUpperCase());
  }

  return found;
}

export function getIdentificationDocumentType(eVisitorIntegrationId: number, docTypeName: "IDENTITY CARD" | "PASSPORT"): number | null {
  // (borna) this... I don't know, I feel like there should be a better way but I can't think of it at the moment
  switch (eVisitorIntegrationId) {
    case EVisitorIntegrationEnum.HR: {
      if (docTypeName === "IDENTITY CARD") {
        return IdentificationDocumentTypesEnum.IdCard_HR_eVisitor;
      } else if (docTypeName === "PASSPORT") {
        return IdentificationDocumentTypesEnum.Passport_HR_eVisitor;
      }
      break;
    }
    case EVisitorIntegrationEnum.SL: {
      if (docTypeName === "IDENTITY CARD") {
        return IdentificationDocumentTypesEnum.IdCard_SL_eTurizem;
      } else if (docTypeName === "PASSPORT") {
        return IdentificationDocumentTypesEnum.Passport_SL_eTurizem;
      }
      break;
    }
    default: {
      if (docTypeName === "IDENTITY CARD") {
        return IdentificationDocumentTypesEnum.IdCard_None;
      } else if (docTypeName === "PASSPORT") {
        return IdentificationDocumentTypesEnum.Passport_None;
      }
      break;
    }
  }

  return null;
}

export function assignToReservationCheckInCustomerData(
  target: ReservationCheckInCustomerData,
  values: OcrData,
  countries: Country[],
  eVisitorIntegrationId: number
) {
  if (!values) return;

  target.identificationDocumentTypeId = getIdentificationDocumentType(eVisitorIntegrationId, values.docType);

  if (values.sex === "Male") {
    target.genderId = 1; // Male
  } else if (values.sex === "Female") {
    target.genderId = 2; // Female
  }

  if (values.docNumber) {
    target.identificationDocumentNumber = values.docNumber;
  }

  if (values.nationality) {
    const found = findCountry(values.nationality, countries);

    if (found) {
      target.countryOfBirthId = found.id;
      target.citizenshipId = found.id;
    }
  }

  if (values.issuingState) {
    const found = findCountry(values.issuingState, countries);

    if (found) {
      target.countryOfResidenceId = found.id;
    }
  }

  if (values.forename) {
    target.firstName = values.forename;
  }
  if (values.secondName) {
    target.middleName = values.secondName;
  }
  if (values.surname) {
    target.lastName = values.surname;
  }

  if (values.dateOfBirth) {
    target.dateOfBirth = values.dateOfBirth.substr(0, 10);
  }

  target.isDirty = true;
  target.isEmpty = false;
}
